<p class="text-headline-medium md:text-headline-large pl-5">Welcome, {{ patronSelectors.fullPreferredName | select }}</p>

<!--
  When less than md, we have a 2x2 grid of stat cards of equal sizes.
  At md, we go to 4x1, but with the first two cards wide enough to fit their content, and the last two splitting the remaining horizontal space.
  At lg, we're still 4x1, but with cards of equal sizes again.
-->
<div class="grid w-full gap-x-3 gap-y-5 grid-cols-2 md:grid-cols-[auto_auto_1fr_1fr] lg:grid-cols-4">
  <px-stat-card titleValue="Ready for Pickup" subtitleLabel="by" [subtitleValue]="readyForPickupSelectors.earliestPickupExpireDate | select"
                subtitleValueFormat="DATE_ONLY" [value]="accountStatusSelectors.readyForPickupHoldsCount | select:0" targetRouteName="HOLDS"
                class="md:w-fit lg:w-full"/>

  <px-stat-card titleValue="Checked Out" subtitleLabel="next due" [subtitleValue]="nextCheckedOutDueDateSelectors.date | select" subtitleValueFormat="DATE_ONLY"
                [value]="accountStatusSelectors.unresolvedCheckoutCount | select:0" targetRouteName="CHECKED_OUT"
                class="md:w-fit lg:w-full"/>

  <px-stat-card titleValue="Balance" subtitleLabel="limit:" [subtitleValue]="accountStatusSelectors.maximumAccountBalance | select:0"
                subtitleValueFormat="CURRENCY" [value]="accountStatusSelectors.currentAccountBalance | select:0" valueFormat="CURRENCY"
                targetRouteName="BALANCE" class="md:w-full"/>

  <px-stat-card titleValue="On Hold" [value]="accountStatusSelectors.onHoldHoldsCount | select:0" targetRouteName="HOLDS" class="md:w-full"/>
</div>

@if (viewportSelectors.isMdAndUp | select) {
  <div class="flex flex-row gap-x-3 w-full">
    <px-recent-notifications/>

    <div class="flex flex-col gap-y-5">
      <px-library-card/>
    </div>
  </div>
} @else {
  <div class="flex flex-col gap-y-5 w-full">
    <px-library-card class="mx-auto"/>
    <px-recent-notifications/>
  </div>
}
